import React, { useEffect } from "react"
import { connect } from "react-redux"

import Header from "./components/Header"
import Footer from "./components/Footer"
import Sidebar from "./components/Sidebar"

import { site } from "config/app";

const AdminLayout = ({children}) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  
  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = site.title
  }, []);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header toggleMenuCallback={"default"} />
        <Sidebar
          theme={"light"}
          type={"default"}
          isMobile={isMobile}
        />
        <div className="main-content">{children}</div>
        {/* <Footer /> */}
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => {
  return {
    ...state.Layout,
  }
}

export default connect(mapStatetoProps)(AdminLayout)
